<template>
  <main>
    <div class="pay-msg">
      <div class="plate">{{carNum}}</div>
      <div class="price">缴费￥ <i>{{fee}}</i> 元</div>
      <div class="content">
        <p>入场时间：{{inTime}}</p>
        <p>停车时长：{{duration}}</p>
      </div>
      <!-- <van-divider :style="{ color: '#ccc', padding: '5px 16px' }" /> -->
      <button class="sure btn btn-green" @click="pay()">
        确定支付
      </button>
    </div>
  </main>
</template>

<script>
import {StringUtil} from '../util/index'
import API from "../api/index";
import { Toast } from 'vant';
import { Cookies } from '../util/index';


export default {
  name: "carinfo",
  data() {
    return {
      radio: "",
      carNum: "",
      fee: "",
      inTime: "",
      duration: "",
      parkId: "",
      bizType: "",
    };
  },

  mounted() {

    this.carNum = this.$route.params.carNum;
    this.fee = this.$route.params.fee;
    this.inTime = this.$route.params.inTime;
    this.duration = this.$route.params.duration;
    this.parkId = this.$route.params.parkId;
    this.bizType = this.$route.params.bizType;
    this.calcMsgId = this.$route.params.calcMsgId;
  },

  methods: {
    link(url) {
      this.$router.push(url);
    },
    
    pay() {

      var _this=this;
      
      this.$http({                   
      method:'post',
        data: {
          userId:Cookies.get("userId"),
          userType:Cookies.get("userType"),
          carNum: _this.carNum,
          parkId: _this.parkId,
          bizType: _this.bizType,
          calcMsgId: _this.calcMsgId,
       },
        url:API.pay_url,
      }).then(function(resp){
       if (resp.data.returnCode != 'SUCCESS') {
         Toast(resp.data.returnMsg);
       } else {
         window.location.href= (resp.data.data.qrurl);
         console.log(resp.data.data.qrurl);
       }
      });
    }
  },
};
</script>

<style scoped>
.pay-msg {
  width: 710px;
  height: 400px;
  background: #fff;
  margin: 20px;
  padding: 20px;
}

.plate {
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 40px;
  color: #343434;
}

.price {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  color: #666666;
  font-family: PingFang SC;
  margin: 50px;
  font-size: 32px;
}

.price i {
  font-size: 60px;
  line-height: 50px;
  color: red;
  margin: 0 20px;
  font-family: PingFang SC;
}

.content p {
  font-size: 32px;
  color: #666666;
}

.why {
  padding-left: 10px;
  color: #343434;
}

.slect {
  width: 300px;
  float: left;
  color: #343434;
}

.sure {
  margin-top: 300px;
}
</style>


// WEBPACK FOOTER //
// src/pages/pay.vue